import { render } from "./MemberCards.vue?vue&type=template&id=352a62c0&scoped=true"
import script from "./MemberCards.vue?vue&type=script&lang=js"
export * from "./MemberCards.vue?vue&type=script&lang=js"

import "./MemberCards.vue?vue&type=style&index=0&id=352a62c0&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352a62c0"]])

export default __exports__